/*
 * Copyright (c) 2025.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/*
* basisdata.ts
* 10-10-2024 - Jelmer Jellema - Spin in het Web B.V.
*
* Te exporteren basisdata
*/

/**
 * alle discprofielen
 */
export const discs = ['D', 'DI', 'DS', 'DC', 'DIS', 'DIC', 'DSC', 'I', 'ID', 'IS', 'IC', 'IDS', 'IDC', 'ISC', 'S', 'SD', 'SI', 'SC', 'SDI', 'SDC', 'SIC', 'C', 'CD', 'CI', 'CS', 'CDI', 'CDS', 'CIS'];

/**
 * Alle mogelijke profielkeuzes
 */
export const profielkeuzes = [
  'NT-vwo',
  'NG-vwo',
  'EM-vwo',
  'CM-vwo',
  'NT-havo',
  'NG-havo',
  'EM-havo',
  'CM-havo',
  'VMBO'
];

export const niveaus = ['wo', 'hbo', 'mbo'];
